import React, {useEffect} from 'react'
import Aos from 'aos';
 

const Workflow = () => {
     useEffect(() =>{
            Aos.init({
            duration: 1000, 
            easing: 'ease-in-out', 
            once: false,  
            offset: 100, 
            });
          }, []);
  return (
    <div id='workflow'>
        <h1 data-aos ='fade-up'>My Workflow</h1>
        <p data-aos ='fade-up'>My creative work process</p>
        <div className='workflow'>

            <div className='process' data-aos = "fade-up"> 
                <div>
                    <h3><span>01.</span> Research & Analysis</h3>
                    {/* <hr /> */}
                </div>
               <div className='process-img-text'>
                <img src={`${process.env.PUBLIC_URL}/images/research.webp`} width='120px' height='80px' />
                <hr />
                 <p>
                    I take time to understand your brand, goals, and audience. With thorough research and discussions,
                     I gather key insights to guide the design process.
                </p>
               </div>
            </div>

             <div className='process' data-aos = "fade-up"> 
                <div>
                    <h3><span>02.</span> Planning & Design</h3>
                    {/* <hr /> */}
                </div>
               <div className='process-img-text'>
                <img src={`${process.env.PUBLIC_URL}/images/design.webp`} width='120px' height='80px' />
                <hr />
                 <p>
                    I begin creating visually engaging and strategic designs, turning your ideas into clear, 
                    effective visuals that reflect and strengthen your brand identity.
                </p>
               </div>
            </div>


            <div className='process' data-aos = "fade-up"> 
                <div>
                    <h3><span>03.</span> Development</h3>
                    {/* <hr /> */}
                </div>
               <div className='process-img-text'>
                <img src={`${process.env.PUBLIC_URL}/images/development.webp`} width='120px' height='80px' />
                <hr />
                 <p>
                   I turn the designs into a fully functional website, carefully coding and 
                   integrating each element to ensure it works smoothly and looks great on all devices.
                </p>
               </div>
            </div>
           
            <div className='process' data-aos ="fade-up"> 
                <div>
                    <h3><span>04.</span> Deployment</h3>
                    {/* <hr /> */}
                </div>
               <div className='process-img-text'>
                <img src={`${process.env.PUBLIC_URL}/images/launch.webp`} width='120px' height='80px' />
                <hr />
                 <p>
                    I thoroughly test the website to make sure everything works perfectly before launch. After it’s live, 
                    I offer support and guidance to help you get the most out of your new site.
                </p>
               </div>
            </div>



        </div>
    </div>
  )
}

export default Workflow